export default __webpack_public_path__ + "static/media/524.a0a76366.gif";